import { render } from "./svg.vue?vue&type=template&id=a8b5151e"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT_REPOS\\pilot-tools\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__